import { useCallback as l } from "react";
const c = (o) => l((t) => {
  var r;
  (r = o.current) == null || r.scrollTo({
    top: t,
    behavior: "smooth"
  });
}, [o]);
export {
  c as useScrollToPosition
};
